/**
 * filterDropdown — reusable custom <select> replacement.
 *
 * Pair it with x-modelable so a parent scope owns the value:
 *
 *   <div
 *     x-data="filterDropdown({ options, placeholder, searchable })"
 *     x-modelable="value"
 *     x-model="municipality"
 *   >
 *
 * Twig markup: templates/_components/filterdropdown.twig
 */
export default function Filterdropdown() {
  Alpine.data(
    "filterDropdown",
    ({ options = [], placeholder = "", searchable = false } = {}) => ({
      options,
      placeholder,
      searchable,

      value: "", // bound to the parent via x-modelable
      open: false,
      query: "",

      // Label for the trigger button
      get label() {
        if (this.value === "") return this.placeholder;
        const match = this.options.find((o) => o.value === this.value);
        return match ? match.label : this.placeholder;
      },

      // Options narrowed by the in-panel search field
      get filteredOptions() {
        const q = this.query.trim().toLowerCase();
        if (!q) return this.options;
        return this.options.filter((o) => o.label.toLowerCase().includes(q));
      },

      toggle() {
        this.open = !this.open;
        if (this.open && this.searchable) {
          this.query = "";
          this.$nextTick(() => this.$refs.search?.focus());
        }
      },

      select(value) {
        this.value = value;
        this.open = false;
      },

      close() {
        this.open = false;
      },
    }),
  );
}
